<template>
  <global-modal :active="isActive" @toggleActive="toggleActive">
    <section class="text-xl font-medium" slot="header">{{ title }}</section>
    <div class="p-5">{{ message }}</div>

    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="flat"
          @click="handleOnCancel"
        >
          {{ cancelTitle }}
        </vs-button>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          v-if="acceptTitle != ''"
          @click="handleOnAccept"
        >
          {{ acceptTitle }}
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      title: "Confirm",
      message: "Are you sure?",
      acceptTitle: "Accept",
      cancelTitle: "Cancel",
      onAccept: () => {},
      onCancel: () => {}
    };
  },
  methods: {
    toggleActive(isActive = true) {
      this.isActive = isActive;
    },
    open({
      title,
      message,
      acceptTitle = "Accept",
      cancelTitle = "Cancel",
      onAccept,
      onCancel
    }) {
      // Properties Setting
      this.title = title;
      this.message = message;
      this.acceptTitle = acceptTitle;
      this.cancelTitle = cancelTitle;
      this.onAccept = onAccept;
      this.onCancel = onCancel;

      // Call
      this.toggleActive(true);
    },

    async handleOnAccept() {
      if (this.isFunction(this.onAccept)) await this.onAccept();
      this.toggleActive(false);
    },

    async handleOnCancel() {
      if (this.isFunction(this.onCancel)) await this.onCancel();
      this.toggleActive(false);
    },

    isFunction(func) {
      return func instanceof Function;
    }
  }
};
</script>
